/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isrunning1Inputs */

const en_entity_isrunning1 = /** @type {(inputs: Entity_Isrunning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Running`)
};

const de_entity_isrunning1 = /** @type {(inputs: Entity_Isrunning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läuft`)
};

/**
* | output |
* | --- |
* | "Is Running" |
*
* @param {Entity_Isrunning1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isrunning1 = /** @type {((inputs?: Entity_Isrunning1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isrunning1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isrunning1(inputs)
	return de_entity_isrunning1(inputs)
});
export { entity_isrunning1 as "entity_isRunning" }